import { appUrls } from "helpers/Urls";
import axiosInstance from "utils/axiosInstance";

const createFormData = (params) => {
    const {
        userData,
        nfcData,
        assistantMappingId,
        isScanCenter
    } = params;
    let formData = new FormData();

    if (!isScanCenter && assistantMappingId) {
        formData.append('AssistantMappingId', assistantMappingId.toString());
    }
    formData.append('NfcData', nfcData ? nfcData : "");
    Object.keys(userData).map((item) => formData.append(item, userData[item] === null ? "" : userData[item]));
    return formData;
};

const registerPatient = async ({ nfcData, userData, assistantMappingId, isScanCenter }) => {
    const header = {
        headers: { 'content-type': 'multipart/form-data' }
    };
    const formData = {
        userData,
        nfcData,
        assistantMappingId,
        isScanCenter
    };

    let res = await axiosInstance.post(appUrls.registerPatient, createFormData(formData), header);
    return { res };
};

export default registerPatient;